<template>
  <div class="tab_container">
    <!-- 基础信息 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        基础信息
        <el-button
          v-if="$route.query.operateType !== '查看'"
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('baseInfo')"
          >保存</el-button
        >
      </div>
    </div>
    <base-info ref="baseInfo" />
    <!-- 宏观环境 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        宏观环境
      </div>
    </div>
    <!-- 政治环境 -->
    <div class="second_title">
      政治环境
      <el-button
        v-if="$route.query.operateType !== '查看'"
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('politicalEnvironment')"
        >保存</el-button
      >
    </div>
    <political-environment ref="politicalEnvironment" />
    <!-- 经济环境 -->
    <div class="second_title">
      经济环境
      <el-button
        v-if="$route.query.operateType !== '查看'"
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('economicEnvironment')"
        >保存</el-button
      >
    </div>
    <economic-environment ref="economicEnvironment" />
  </div>
</template>

<script>
import BaseInfo from "./baseInfo.vue";
import PoliticalEnvironment from "./politicalEnvironment.vue";
import EconomicEnvironment from "./economicEnvironment.vue";
import { getMarketInfoApi } from "@/api/saleTaskCollection";

export default {
  components: {
    BaseInfo,
    PoliticalEnvironment,
    EconomicEnvironment
  },
  data() {
    return {};
  },
  mounted() {
    this.getMarketInfo();
  },
  methods: {
    // 获取市场信息
    async getMarketInfo() {
      try {
        let data = {};
        if (this.$route.query.areaName && this.$route.query.countryName) {
          const res = await getMarketInfoApi({
            areaName: this.$route.query.areaName,
            countryName: this.$route.query.countryName
          });
          if (res.status == 0) {
            data = res.data || {};
          } else {
            this.$DonMessage.error(res.message);
          }
        }
        this.$refs.baseInfo.init(data.saleInformation);
        this.$refs.politicalEnvironment.init(data.saleInformation);
        this.$refs.economicEnvironment.init(data.historyYearsRate);
      } catch (error) {}
    },
    // 保存
    handleSave(refField) {
      let submitData = {};
      if (refField !== "baseInfo") {
        if (!this.$route.query.baseInfoId) {
          this.$DonMessage.warning("请先保存基础信息")
          return;
        }
        submitData = {
          id: this.$route.query.baseInfoId,
          areaName: this.$route.query.areaName,
          countryName: this.$route.query.countryName
        };
      }
      this.$refs[refField].handleSave(submitData);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_container {
  padding-bottom: 20px;
  .hearder_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title_icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .title_btn {
    margin-left: 20px;
  }
}
</style>
